// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, {PropTypes, Component} from 'react';

import _ from 'lodash';

import cx from 'classnames';

// import customized material UI components
import RaisedButton from '../c_RaisedButton';

import Modal from '../r_Modal';
import Logo from '../../svgs/Logo';
import ModalX from '../../svgs/ModalX';


export default class ModalForm extends Component {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.any.isRequired,
    onClose: PropTypes.func,
    prompt: PropTypes.string,
    message: PropTypes.bool,
    style: PropTypes.object,
    transparent: PropTypes.bool,
    dataId: PropTypes.string,
    button: PropTypes.shape({
      className: PropTypes.string,
      label: PropTypes.string,
      style: PropTypes.object,
      disabled: PropTypes.bool,
      hide: PropTypes.bool,
      onClick: PropTypes.func
    }),
    afterButtonText: PropTypes.shape({
      className: PropTypes.string,
      content: PropTypes.any,
      onClick: PropTypes.func
    })
  }

  static defaultProps = {
    button: {},
    afterButtonText: {}
  }

  handleClose = () => {
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  render() {
    const {
      message: isMessage,
      className,
      style,
      transparent,
      prompt,
      dataId,
      children
    } = this.props;

    const {
      className: buttonClassName,
      label: buttonLabel,
      style: buttonStyle,
      hide: buttonHide,
      onClick: buttonOnClick,
      disabled: buttonIsDisabled,
      ...otherButtonProps
    } = this.props.button;

    const {
      className: afterButtonTextClassName,
      content: afterButtonTextContent,
      onClick: afterButtonTextOnClick,
      ...otherAfterButtonTextProps
    } = this.props.afterButtonText;

    return (
      <Modal
        fadeModal={!!this.props.onClose}
        fadeModalChildren={!!this.props.onClose}
        show
        floatDownModalChildren
        transformTransitionOut='ease-in-out'
        onClose={this.props.onClose && this.handleClose}>

        <ModalFormMain isMessage={isMessage}
                       className={className}
                       style={style}
                       transparent={transparent}
                       prompt={prompt}
                       children={children}
                       buttonClassName={buttonClassName}
                       buttonLabel={buttonLabel}
                       dataId={dataId}
                       buttonStyle={buttonStyle}
                       buttonHide={buttonHide}
                       buttonIsDisabled={buttonIsDisabled}
                       buttonOnClick={buttonOnClick}
                       otherButtonProps={otherButtonProps}
                       afterButtonTextClassName={afterButtonTextClassName}
                       afterButtonTextContent={afterButtonTextContent}
                       afterButtonTextOnClick={afterButtonTextOnClick}
                       otherAfterButtonTextProps={otherAfterButtonTextProps} />
        <div className='rectangle-behind-modal-form absolute-center'/>
      </Modal>
    );
  }
}


// hack for incorporating close on key press
class ModalFormMain extends Component {
  static propTypes = {
    closeModal: PropTypes.func,
    children: PropTypes.any,
    className: PropTypes.string,
    style: PropTypes.object,
    isMessage: PropTypes.bool,
    transparent: PropTypes.bool,
    prompt: PropTypes.string,
    buttonClassName: PropTypes.string,
    dataId: PropTypes.string,
    buttonLabel: PropTypes.string,
    buttonHide: PropTypes.bool,
    buttonIsDisabled: PropTypes.bool,
    buttonStyle: PropTypes.object,
    buttonOnClick: PropTypes.func,
    otherButtonProps: PropTypes.object,
    afterButtonTextContent: PropTypes.any,
    afterButtonTextClassName: PropTypes.string,
    afterButtonTextOnClick: PropTypes.func,
    otherAfterButtonTextProps: PropTypes.object,
  }

  constructor() {
    super();

    this.respondToKeyPress = ::this.respondToKeyPress;
  }

  componentDidMount() {
    window.addEventListener('keydown', this.respondToKeyPress);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.respondToKeyPress);
  }

  respondToKeyPress(event) {
    // escape key response
    if(event.keyCode === 27 && this.props.closeModal) {
      this.props.closeModal();
    }

    // enter key response
    if(event.keyCode === 13 && !this.props.buttonIsDisabled && this.props.buttonOnClick) {
      this.props.buttonOnClick();
    }
  }

  render() {
    return (
      <div className={cx('modal-form', 'clearfix', this.props.className, {'modal-message': this.props.isMessage})} style={this.props.style}>
        <div className={cx('message-container', {transparent: this.props.transparent})}>
          {
            !this.props.isMessage
            &&
            <div>
              <Logo className='logo'/>
              <div className='prompt-container'>
                <span className='prompt'>
                  {this.props.prompt}
                </span>
              </div>
              <div className='form-container'>
                {this.props.children}
              </div>
            </div>
            ||
            this.props.children
          }
          <RaisedButton className={`form-submit ${this.props.buttonClassName}`}
                        data-id={this.props.dataId || this.props.buttonLabel}
                        label={this.props.buttonLabel}
                        disabled={this.props.buttonIsDisabled}
                        style={_.merge({ marginTop: '40.5px'}, this.props.buttonHide ? {opacity: 0, visibility: 'hidden'} : {}, this.props.buttonStyle)}
                        onClick={this.props.buttonOnClick}
                        {...this.props.otherButtonProps}/>
          <div className={`after-button-text ${this.props.afterButtonTextClassName} ${this.props.afterButtonTextOnClick ? 'clickable' : ''}`}
               data-id='After Button Text'
               onClick={this.props.afterButtonTextOnClick}
               {...this.props.otherAfterButtonTextProps}>
            {this.props.afterButtonTextContent}
          </div>
        </div>
        {
          !!this.props.closeModal
          &&
          <ModalX onClick={this.props.closeModal}/>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/common/components/c_ModalForm/index.js